import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-permission',
  templateUrl: './permission-issue.component.html',
  styleUrls: ['./permission-issue.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class PermissionComponent {
  constructor() {
    // No dependencies to inject
  }
}
